import { ArrowDown } from "lucide-react";

const QuickActions = ({ t, styles, scrollToSection }) => {
  return (
    <div style={styles.quickActionsGrid}>
      {/* Documents Card */}
      <div
        style={styles.card1}
        onClick={() => scrollToSection("documents-section")}
      >
        <h3 style={styles.quickActionTitle}>{t.myDocuments}</h3>
        <p style={styles.quickActionDescription}>{t.myDocumentsDesc}</p>
        <div style={styles.quickActionArrow}>
          {t.goToDocuments}
          <ArrowDown size={18} />
        </div>
      </div>

      {/* Solfa Card */}
      <div
        style={styles.card1}
        onClick={() => scrollToSection("advancement-section")}
      >
        <h3 style={styles.quickActionTitle}>{t.solfaRequests}</h3>
        <p style={styles.quickActionDescription}>{t.solfaRequestsDesc}</p>
        <div style={styles.quickActionArrow}>
          {t.goToSolfa}
          <ArrowDown size={18} />
        </div>
      </div>
    </div>
  );
};

export default QuickActions;